import React, { memo, useCallback, useMemo } from 'react';

import EntityLink from 'components/EntityLink';
import { CONTACTS } from 'constants/Entities';
import DetailField from 'containers/components/EntityDetailPopover/DetailField';
import useEntityDetail from 'containers/components/EntityDetail/hooks/useEntityDetail';
import { canViewEntity } from 'utils/entityPermissions';
import { stopEntityNavigation } from 'utils/entityNavigation';
import { getContactFormUrl } from 'utils/getUrl';

const ContactField = memo(({ contact, onClick }) => {
    const { hasTabsEnabled, openTab } = useEntityDetail();
    const contactId = contact?.value;

    const handleOnClick = useCallback(
        (event) => {
            if (!canViewEntity(CONTACTS)) return stopEntityNavigation(event);
            if (!hasTabsEnabled || event.ctrlKey) return true;

            event.stopPropagation();
            event.preventDefault();
            onClick?.();
            openTab({
                entity: CONTACTS,
                id: contactId,
                hasCrudInDetail: true,
                toTab: false,
                avoidRedirects: true,
            });
        },
        [contactId, hasTabsEnabled, onClick, openTab],
    );

    const component = useMemo(
        () => (
            <EntityLink
                entity={CONTACTS}
                href={getContactFormUrl(contactId)}
                onClick={handleOnClick}
                linkProps={{ className: 'fm-agenda-small-detail__link', target: 'blank' }}
                textProps={{ className: 'fm-agenda-small-detail__link' }}
            >
                {contact?.label}
            </EntityLink>
        ),
        [contact?.label, contactId, handleOnClick],
    );

    if (!contactId || String(contactId) === '-1' || !contact?.label) return null;

    return <DetailField iconProps={{ name: 'contacts' }} component={component} />;
});

export default ContactField;
